import { render, staticRenderFns } from "./BoCustomerType.vue?vue&type=template&id=4fbd0bc8"
import script from "./BoCustomerType.vue?vue&type=script&lang=js"
export * from "./BoCustomerType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports